import { useEffect } from "react";
import Lenis from "lenis";
import "./App.css";

import FilmGrain from "./components/FilmGrain";
import SectionNav from "./components/SectionNav";
import DisclaimerBanner from "./components/DisclaimerBanner";
import Hero from "./components/Hero";
import MissionRecapSection from "./components/MissionRecapSection";
import SpecialHoursSection from "./components/SpecialHoursSection";
import VerseSection from "./components/VerseSection";
import HeritageSection from "./components/HeritageSection";
import ScheduleSection from "./components/ScheduleSection";
import ServicesSection from "./components/ServicesSection";
import GatewaySection from "./components/GatewaySection";
import MembershipSection from "./components/MembershipSection";
import EsteMesCarousel from "./components/EsteMesCarousel";
import VenezuelaSection from "./components/VenezuelaSection";
import FamilyCampSection from "./components/FamilyCampSection";
import NacionSection from "./components/NacionSection";
import PrayerSection from "./components/PrayerSection";
import MissionsMinistrySection from "./components/MissionsMinistrySection";
import SummerServeSection from "./components/SummerServeSection";
import FestivalSection from "./components/FestivalSection";
import FestivalRecapSection from "./components/FestivalRecapSection";
import LegalSection from "./components/LegalSection";
import MinisteriosSection from "./components/MinisteriosSection";
import PastorSection from "./components/PastorSection";
import SiteFooter from "./components/SiteFooter";
import content from "./content";

const SECTIONS = [
  { id: "inicio", label: "Inicio" },
  { id: "nicaragua", label: "Nicaragua", hidden: content.missionRecap?.hidden },
  { id: "verso", label: "Verso" },
  { id: "servicios", label: "Revive", hidden: content.services?.hidden },
  { id: "este-mes", label: "Este Mes" },
  { id: "herencia", label: "Un Solo Pueblo", hidden: content.heritage?.hidden },
  { id: "oracion", label: "Oración" },
  { id: "horario", label: "Horario" },
  { id: "misiones", label: "Misiones" },
  { id: "gateway", label: "Gateway" },
  { id: "pastor", label: "Pastor" },
].filter((s) => !s.hidden);

function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;

    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App relative bg-ink text-ceramic">
      <FilmGrain />
      <SectionNav sections={SECTIONS} />
      <DisclaimerBanner />
      <main>
        <Hero />
        <MissionRecapSection />
        <VerseSection />
        <ServicesSection />
        <EsteMesCarousel />
        <HeritageSection />
        <PrayerSection />
        <ScheduleSection />
        <FestivalSection />
        <FestivalRecapSection />
        <MembershipSection />
        <MissionsMinistrySection />
        <SummerServeSection />
        <GatewaySection />
        <PastorSection />
      </main>
      <SiteFooter />
    </div>
  );
}

export default App;
